import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { TrainingExternalItem } from '../../models/external';
import { supplierEmployeeService } from '@api/services/services';

export type TrainingExternalListState = ListType<TrainingExternalItem, ListFilter>;

const initialState: TrainingExternalListState = {
  state: FetchState.None,
  data: undefined,
  query: {},
};

export const trainingExternalListSlice = listSlice({
  name: 'trainingExternalList',
  initialState,
});

export const selectTrainingExternalList = (state: RootState) => state.trainingExternalList;
export const trainingExternalListActions = trainingExternalListSlice.actions;

export const getTrainingExternalListByUserId = (userId: string, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectTrainingExternalList(storeState);

  const handleGetData = (size: number) => {
    return supplierEmployeeService.getInvitationsData(
      userId,
      {
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken as any },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: trainingExternalListActions,
    getData: handleGetData,
  });
};
